export const mainPath = "https://hhghr.beupsoft.pl/api";

